<template>
  <h1>Not Found... 404...</h1>
  <router-link :to="{ name: 'Home' }">Go to Home</router-link>
</template>

<script>
export default {};
</script>

<style>
</style>